import { IThunkActionCreator } from '../../types/store';
import { changePage } from '../filters/actions';
import { onRoadsPopupAccept } from '../roads/actions';
import { onStationsPopupAccept } from '../stations/actions';
import { CommutePopupTabs } from '../../interfaces/filters';

export interface ICommutePopupOpened {
  type: 'CommutePopupOpened';
  opened: boolean;
}

export interface ICommutePopupTabChanged {
  type: 'CommutePopupTabChanged';
  value: CommutePopupTabs;
}

export const changeCommutePopupTab = (value: CommutePopupTabs): ICommutePopupTabChanged => ({
  type: 'CommutePopupTabChanged',
  value,
});

export const showCommutePopup =
  (opened = true): IThunkActionCreator =>
  dispatch => {
    dispatch<ICommutePopupOpened>({
      opened,
      type: 'CommutePopupOpened',
    });
  };

export const onCommutePopupAccept = (): IThunkActionCreator => dispatch => {
  dispatch(onRoadsPopupAccept());
  dispatch(onStationsPopupAccept());
  dispatch(changePage(1));
};

export type Action = ICommutePopupOpened | ICommutePopupTabChanged;
